export function generateSuggestions(items, searchTerm, maxCount = 5) {
  if (!searchTerm) return [];
  const lower = searchTerm.toLowerCase();
  return items.filter(item => item.name.toLowerCase().includes(lower)).slice(0, maxCount);
}
